export default(data, action) => {
    switch(action.type) {        
        case "SET":
            return action.payload;
        default: 
            return data;
    }
}